import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhatItIsSection() {
  const scrollToFinalCTA = () => {
    document.getElementById('final-cta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-warm-white py-16 md:py-24 px-4" data-id="element-272">
      <div className="max-w-5xl mx-auto" data-id="element-273">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mb-12" data-id="element-274">
          {/* Left Column - What it IS */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-card border-t-4 border-sage" data-id="element-275">
            <div className="flex items-center gap-3 mb-6" data-id="element-276">
              <div className="bg-sage/10 p-2 rounded-full" data-id="element-277">
                <Check className="w-6 h-6 text-sage" data-id="element-278" />
              </div>
              <h3 className="text-2xl font-heading font-bold text-olive" data-id="element-279">
                Qué SÍ es esta guía
              </h3>
            </div>

            <ul className="space-y-4" data-id="element-280">
              {['Un protocolo realista para mujeres que necesitan descansar', 'Explicaciones claras sobre qué pasa con tus hormonas y el sueño', 'Estrategias comprobadas para regular el cortisol y la melatonina', 'Una invitación a recuperar tu energía de forma natural'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-281">
                  <Check className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-282" />
                  <span className="text-warm-gray" data-id="element-283">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Right Column - What it is NOT */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-card border-t-4 border-red-400/60" data-id="element-284">
            <div className="flex items-center gap-3 mb-6" data-id="element-285">
              <div className="bg-red-50 p-2 rounded-full" data-id="element-286">
                <X className="w-6 h-6 text-red-400" data-id="element-287" />
              </div>
              <h3 className="text-2xl font-heading font-bold text-olive" data-id="element-288">
                Qué NO es
              </h3>
            </div>

            <ul className="space-y-4" data-id="element-289">
              {['No son pastillas para dormir que te dejan atontada', 'No requiere rutinas de 2 horas antes de acostarte', 'No promete milagros sin hacer pequeños ajustes'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-290">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-291" />
                  <span className="text-warm-gray" data-id="element-292">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-293">
          <button onClick={scrollToFinalCTA} className="inline-block bg-sage hover:bg-sage-dark text-white font-bold py-4 px-10 rounded-full transition-all transform hover:scale-[1.02] shadow-md text-lg" data-id="element-294">
            Quiero empezar hoy
          </button>
        </motion.div>
      </div>
    </section>;
}